const translation = {
  generic: {
    footer: {
      twitter: 'Twitter',
      github: 'GitHub',
      text: '2024 DeWiCats, Inc. All rights reserved.',
    },
    connectWallet: 'Please connect your wallet',
    comingSoon: 'Coming Soon',
    noResults: 'No matches found.',
    error: {
      message: 'Failed to load.',
      buttonTitle: 'Retry',
    },
    loadingDialog: 'Submitting...',
    newNFTs: 'A new class of NFTs built for the people.',
    hotspotRewards:
      'DeWiCats come with a unique PFP design that allows you to claim hotspot rewards being generated in the treasury. The split of mining rewards will be distributed evenly among all holders everyday.',
  },
  components: {
    tokenCard: {
      noPriceAvailable: 'No price available',
    },
    buyDropdown: {
      buy: 'Buy',
      magicEden: 'Magic Eden',
      tensor: 'Tensor',
    },
    connectButton: {
      title: 'Connect',
    },
    navBar: {
      title: 'DeWiCats',
    },
    proposalNavBar: {
      proposalNumber: 'Proposal #{{ number }}',
      active: 'Active',
      votingClosed: 'Voting Closed',
      draft: 'Draft',
      inReview: 'In Review',
      executed: 'Executed',
      vetoed: 'Vetoed',
      rejected: 'Rejected',
      voteFor: 'Vote For',
      vote: 'Vote',
      voteAgainst: 'Vote Against',
      voteAbstain: 'Abstain Vote',
      saveAndSubmit: 'Save',
      review: 'Review',
      publish: 'Publish',
      numberOfVotes: '{{ start }} / {{ end }} votes',
    },
    heliumSolanaMigrationBanner: {
      title: 'Helium to Solana Migration in Progress',
    },
  },
  dewiHallEntry: {
    overview: 'Overview',
    overviewDescription: `DeWiCats aims to revolutionize the PFP space on Solana and expand
    the innovative DePIN Space. With a unique funding model backed by
    Helium hotspots, DeWiCats is poised to offer unparalleled
    experiences and projects to its holders, setting new standards in
    the NFT realm.`,
    overviewObjectives: 'The objectives of DeWiCats are multifaceted:',
    objective1: `To propel the DeWiCats and DePIN brands to new heights,transcending the conventional boundaries of the NFT space.`,
    objective2: `To leverage the financial stability and innovation offered by Helium hotspots to fuel their mission and projects.`,
    objective3: `To deliver exceptional, diverse experiences and projects to DeWiCats holders, enriching their involvement and investment in the ever-evolving DeWiCats ecosystem.`,
    objectiveSummary: `Through these endeavors, DeWiCats aspires to lead a transformative movement in the PFP domain on the Solana blockchain, setting new standards for creativity, community engagement, and technological integration.`,
    fundingTitle: 'DeWiHall will be funded through',
    fundingReason1Title: '1M',
    fundingReason1Desc: 'Initial MOBILE injection from DeWiCats Team',
    fundingReason2Title: '10',
    fundingReason2Desc: 'Helium Hotspots from DeWiCats Team',
    fundingReason3Title: '80%',
    fundingReason3Desc: 'of proceeds from auctioned DeWiCats',
    fundingReason4Title: '1%',
    fundingReason4Desc: 'Of secondary royalties from DeWiCats',
    meowAmendmentsTitle: 'Meow Amendments',
    one: '01',
    meowAmendmentTitle: 'Legal Paws Clause:',
    meowAmendmentDesc: ` 100% of proposals must receive legal clearance before implementation.`,
    two: '02',
    meowAmendmentTitle2: 'Unanimous Retract Pawvision:',
    meowAmendmentDesc2: ` Requires 90% consensus for the abolition of a Meow Amendment.`,
    three: '03',
    meowAmendmentTitle3: 'Community Whiskers Act:',
    meowAmendmentDesc3: `  At least 60% approval is needed to approve proposals.`,
    four: '04',
    meowAmendmentTitle4: 'Nine Lives Fund Principle:',
    meowAmendmentDesc4: `  No single proposal can allocate more than 20% of the treasury's current funds.`,
    five: '05',
    meowAmendmentTitle5: 'Legendary Grant Provision:',
    meowAmendmentDesc5: ` The team can issue 25 Legendary Cats to notable community members.`,
    six: '06',
    meowAmendmentTitle6: 'Treasury Allocation Edict:',
    meowAmendmentDesc6: ` 80% of auction proceeds are designated for the treasury, and 20% for DeWiCats LLC.`,
    seven: '07',
    meowAmendmentTitle7: 'Yearly Meow-a-thon:',
    meowAmendmentDesc7: ` A 365-cat auction will span one year, introducing new DeWiCats to the community.`,
    eight: '08',
    meowAmendmentTitle8: 'Paws of Power Rule:',
    meowAmendmentDesc8: `  In the future, each Legendary Cat will carry 2 voting points, while all other cats will have 1, pending team development.`,
    votingPower: 'Voting Power',
    votingPowerSubtitle: 'Every DeWiCat has a voting power of 1',
    votingPowerFuture:
      'In the future each Legendary Cat will carry 2 voting points, pending team development.',
    connectYourWallet: 'Connect your wallet to view your voting power',
    dewiHall: 'DeWiHall',
    dewi: 'Dewi',
    hall: 'Hall',
    subtitle: `Home of the DeWiCats community and the DeWiCats DAO. The DeWiHall is the central hub for all DeWiCats proposals and community discussions.`,
    browseProposals: 'Browse Proposals',
    faqTitle: 'Frequently Asked Questions',
    loading: 'Loading...',
  },
  mintPage: {
    title: 'DeWiCats NFT',
    subtitle1:
      'Every DeWiCat is unique and has a unique personality. They are designed to be a fun and interactive way to learn about 5G and DeWi.',
    subtitle2:
      'Join DeWiCats on its mission to provide free 5G to low income families!',
    unknown: '?#',
  },
  treasuryPage: {
    title: 'Treasury',
    totalHoldingsBalance: 'Total Holdings Balance',
    copiedAddress: 'Address copied: {{ address }}',
    tokens: 'tokens',
    miners: 'miners',
  },
  gamePage: {
    title: 'Dewi Game',
    subtitle: 'Fire game',
    currentRewards: 'Game current rewards: {{ amount }} {{ ticker }}',
    claimRewards: 'Claim {{ ticker }}',
  },
  descriptionPage: {
    title: 'NFTs, Reimagined. DePIN, Empowered.',
    text: 'DeWiCats is a groundbreaking NFT collection, backed by DePIN hardware. A new DeWiCat is born every day, unlocking membership to an exclusive club. Powered by Helium Modular Governance, holders can propose and vote on game-changing DePIN ideas, with funding sourced from the project’s treasury. With DeWiCats, you’re not just collecting — you’re shaping the future of decentralized infrastructure.',
  },
  RightFromTheBeginningPage: {
    title: 'BUILT RIGHT FROM THE BEGINNING',
    images: [
      { title: 'You own the IP' },
      { title: 'IPFS-hosted (on-chain coming)' },
      { title: 'Utility NFT that unlocks while held' },
      { title: 'Access to the exclusive DAO funded by DeWiCats' },
    ],
  },
  UtilityDescriptionPage: {
    title:
      'The first utility NFT powered by cutting-edge decentralized hardware.',
    text1: `At DeWiCats, we're redefining what a utility NFT truly means. Each DeWiCat unlocks your access to an exclusive DAO, powered by decentralized networks and hardware. Once inside, you gain access to exclusive drops, community meetups, real-world events, and early access to future projects—including our groundbreaking initiative, Project AirClaw.`,
  },
  roadmapPage: {
    title: 'Roadmap',
    items: [
      {
        title: 'First DewiCats are born',
        subtitle:
          'All allowlist members will receive a DeWiCat Box NFT that will be redeemable for a DeWiCat. The DeWiCat Box NFT will be reedemable for a DeWiCat via the Art-Engine website. Holders will be able to create their DeWiCat and mint it to their wallet.',
        date: 'Q1 2024',
      },
      {
        title: 'DeWiHall Custom DAO Launch',
        subtitle:
          'All DeWiCats holders will be able to create and vote on proposals for the DeWiCats DAO. The DAO will be funded by the DeWiCats treasury and will be used to fund future DeWiCats projects.',
        date: 'Q1 2024',
      },
      {
        title: 'Auction Page Launch',
        subtitle:
          'The auction page will be launched where users will be able to bid on a DeWiCat that is born every 24 hours. The auction will last 24 hours and the highest bidder will win the DeWiCat.',
        date: 'Q2 2024',
      },
      {
        title: 'Deploy DePIN Hardware',
        subtitle:
          'DeWiCats will deploy DePIN hardware to the community treasury.',
        date: 'Q4 2024',
      },
      {
        title: 'Project AirClaw: The Future, Unbound',
        subtitle:
          'A quiet evolution in decentralized systems, Project AirClaw opens the door to a new realm of possibilities. DeWiCat holders will be the first to experience this shift, with exclusive early access to what lies ahead.',
        date: 'Q1 2025',
      },
    ],
  },
  faq: {
    title: 'Frequently Asked Questions',
    dewiHallEntryItems: [
      {
        title: 'Is every vote public?',
        content:
          'Yes every vote is public and can be viewed on the Solana blockchain.',
      },
      {
        title: 'How do I submit a proposal?',
        content:
          'You can submit a proposal by starting a proposal draft and then submitting it for review.',
      },
      {
        title: 'How do I vote on a proposal?',
        content:
          'You can vote on a proposal by clicking on the proposal and then selecting your vote.',
      },
      {
        title: 'Do you need to be a DeWiCats holder to submit a proposal?',
        content: 'Yes, you need to be a DeWiCats holder to submit a proposal.',
      },
    ],
    accordionItems: [
      {
        title: 'Is there a Discord?',
        content: 'Yes! Join our discord at https://discord.gg/xrPTTn2A94',
      },
      {
        title: 'What is the exclusive funded DAO?',
        content:
          'DeWiCats is a utility NFT, offering a range of benefits. One of these is access to an exclusive fund supported by decentralized infrastructure. As a holder, you have the power to decide how these rewards are utilized. By owning a DeWiCat, you gain voting power to influence how resources are deployed and where those rewards are directed. Together, let’s shape the future of decentralized, community-driven projects! 🚀',
      },
      {
        title: 'Is there a guaranteed mint allowlist?',
        content: 'First 69 cats were minted to allowlist members.',
      },
      {
        title: 'What is a Legendary DeWiCat?',
        content:
          'Legendary DeWiCats are special DeWiCats that are unique and hold 1 out of 1 traits that are not available on the art engine.',
      },
      {
        title: 'How many Legendary DeWiCats are there?',
        content:
          'DeWiCats Founders hold the first 25 Legendary DeWiCats which will be offered to special community members. There will also be some Legendary DeWiCats that will be available to the public via the auction. More details coming soon. 🤫',
      },
      {
        title: 'How are the first DeWiCats distributed?',
        content:
          'The first DeWiCats will be distributed via an airdrop where users will be airdropped a DeWiCat Box NFT that will be redeemable for a DeWiCat. The DeWiCat Box NFT will be reedemable for a DeWiCat via the Art-Engine website. Holders will be able to create their DeWiCat and mint it to their wallet.',
      },
      {
        title: 'What intellectual property rights do DeWiCats holders receive?',
        content:
          'Owners of DeWiCats have full commercial art rights for the DeWiCat they own.',
      },
      {
        title: 'What are the mining funds being used for?',
        content:
          '100% of proceeds go directly to DeWiCats Treasury / Members. We are a community funded project and we plan to use the funds to grow the DeWiCats community and fund future projects.',
      },
      {
        title: 'Is there a future roadmap?',
        content:
          'Here at DeWiCats we plan to take quality to the next level. That is why we plan to release DeWiCats with an exclusive DAO where DeWiCat holders will be able to vote and view the treasuries mining rewards. Holders can use these rewards to fund cool DePIN projects.',
      },
      {
        title: 'What are secondary royalties and how will they be used?',
        content:
          'Dewicats secondary sales will be disbursed in three parts.</br> • DeWiCats Creators will receive a percentage of all secondary sales. To be determined.</br>• DeWiCats DAO will receive 1% of all secondary sales.</br> • Helium Foundation will receive 1% of all secondary sales.</br>',
      },
      {
        title: 'Will DeWiCats be revealed right away?',
        content:
          'No! First DeWiCats will be created by the holders via the Art-Engine website. Holders will be able to create their DeWiCat and mint it to their wallet.',
      },
      {
        title: 'What if I missed the airdrop?',
        content:
          'You will need to secure a DeWiCat from the secondary market or from the daily auctions.',
      },
    ],
  },
  holdings: {
    noWalletConnected: "Couldn't find wallet.",
    noNfts: 'No NFTS found.',
    stakeAll: 'Stake all',
    unstakeAll: 'Unstake all',
    holdingCard: {
      tooltip: {
        multiplier: '{{ multiplier }}x',
        earned: 'This cat has a {{ multiplier }}x for all things DeWiCats',
      },
      unstakeDialog: {
        messageReadyToUnstake: 'Your DeWiCat is ready to be unstaked.',
        message:
          'To initiate unstaking, you must first enter a 30-day cooldown period. After this period ends, you will be able to proceed with unstaking.',
      },
      copiedReferral: 'Copied to clipboard.',
      earned: 'Earned',
      referral: 'Referral Code',
      name: 'DeWiCat #{{ number }}',
      unstake: 'Unstake',
      stake: 'Stake',
      initializedUnstake: 'Start Cooldown',
      cooldown:
        'Cooldown for {{ days }} days, {{ hours }} hours, {{ minutes }} minutes, {{ seconds }} seconds',
    },
    details: {
      status: {
        staking: 'Staking',
        referred: 'Referred',
      },
      table: {
        dewicat: 'DeWiCat',
        date: 'Date',
        status: 'Status',
      },
      referralCount: 'Referral Count',
      tokenEarned: 'Token Earned',
      claimAll: 'Claim All',
      mobileEarned: '{{ mobile }} MOBILE',
      usdEarned: '{{ usd }} USD',
      claim: 'Claim',
      claimSol: 'Claim ~{{ amount }} SOL',
      exit: 'Exit',
      traits: 'Traits',
      tokenNotFound: 'Token not found.',
    },
  },
  explorerPage: {
    modal: {
      applyButton: 'Apply',
      clearButton: 'Clear',
    },
    loadingCard: {
      title: 'Loading...',
    },
    headerTitle: {
      supply: 'Supply',
      legendary: 'Legendaries',
      auctioned: 'Auctioned',
      owners: 'Owners',
      burnt: 'Burnt',
    },
    navTitle: {
      leaderboard: 'leaderboard',
      overview: 'overview',
      attributes: 'attributes',
    },
    leaderboard: {
      trait: 'Trait',
      floor: 'Floor',
      headgear: 'Headgear',
    },
    overview: {
      cardInfo: {
        listed: 'Listed',
        unminted: 'Unminted',
      },
      nftDetails: {
        title: '{{ number }}',
        error: 'NFT not found.',
        exit: 'Exit',
      },
      form: {
        search: 'Search by ID',
        select: 'Select',
        emptyValue: 'Select',
        legendary: 'Show Legendaries',
        staked: 'Show Staked',
        listed: 'Listed in market',
        background: 'Background',
        headgear: 'Headgear',
        whiskers: 'Whiskers',
        noses: 'Noses',
        filters: 'Filters',
        status: 'Status',
        attributes: 'Attributes',
      },
    },
  },
  dao: {
    activeProposals: 'Proposals',
    metadataLost:
      'The details for this MIP were lost when Shadow Drive shut down. Join the DeWiCats Discord for more information on it.',
    discordCta: 'Join the Discord',
    myDrafts: 'My Drafts',
    submittedDrafts: 'Proposals in Review',
    forReview: 'For Review',
    titleCard: {
      dewiHall: 'DeWi Hall',
      proposals: 'Proposals',
      description:
        'Welcome to the DeWiHall, a space for DeWiCat members to browse current and historical proposals from the builders and creators of the community.',
      connectButton: 'Connect',
      submitButton: 'Submit a proposal',
    },
    proposalCard: {
      status: {
        active: 'Active',
        inactive: 'Inactive',
        daysLeft: '{{ expiry }} days left',
      },
      votes: '{{ votes }} votes',
    },
    newProposalForm: {
      tldr: 'TLDR',
      saveDraft: 'Save Draft',
      titlePlaceholder: 'Write proposal title here...',
      textPlaceholder: "Enter text or type '/' for commands.",
      uploadImage: 'Upload Image',
      addNewSection: 'Add new section',
      confirmSave: 'Are you sure you want to save this proposal as a draft?',
      cancel: 'Cancel',
      save: 'Save',
      submit: 'Submit',
      delete: 'Delete',
      publish: 'Publish',
      errors: {
        noWallet: 'Please connect your wallet to continue',
        noTitle: 'Please enter a proposal title',
        noContent: 'Please add at least one content section to your proposal',
        noImage: 'Please upload an image for your proposal',
      },
    },
    proposalDetails: {
      favor: 'In favor',
      against: 'Against',
      neutral: 'Neutral',
      castVote: 'Cast your vote for this proposal',
      proposalLinkCopied: 'Proposal link copied',
      errorCastVote: 'There was an error casting your vote',
      clickOnErrorLink: 'Click here to learn more about the error',
      viewOnExplorer: 'View on Explorer',
      proposer: 'Proposed by {{ proposer }} ',
    },
  },
  connectWallet: {
    connectButton: 'Connect',
    authenticateCode: {
      error: 'Wrong pin',
      title: 'Please enter the code sent to',
    },
    connected: {
      copyAddress: 'Copy address',
      changeWallet: 'Change Wallet',
      disconnect: 'Disconnnect',
    },
    email: {
      error: 'Type a valid email',
      submit: 'Submit',
      title: 'Continue with email',
    },
    login: {
      email: 'Login with email',
      wallet: 'Login with wallet',
      title: 'Connect to DeWiCats',
    },
    wallets: {
      lessOptions: 'Less options',
      moreOptions: 'More options',
      title: 'Select your Solana wallet to continue.',
      connected: 'Connected',
      detected: 'Detected',
    },
  },
  table: {
    paginationDescription:
      'Showing {{ startIndex }} to {{ endIndex }} of {{ length }} results',
  },
  auction: {
    title: 'DeWiCat {{ currentDewi }}',
    originalSixtyNine: {
      title: 'The Original 69 DeWiCats',
      subtitle1: `During the exclusive DeWiCat Genesis days, a select group of allowlist
      members were given the honor of minting their own special DeWiCat
      Boxes. With these boxes, they crafted their custom DeWiCats, infusing
      each with a distinctive personality and flair. These 69 pioneers are
      not just DeWiCats; they are the foundation of our vibrant community.`,
      subtitle2: `Every Original 69 DeWiCat is a symbol of our early days, representing
      the spirit and passion of our initial supporters. These are the
      meow-gical cats that started it all, setting the stage for the
      flourishing DeWiCats universe.`,
    },
    giftedLegendaries: {
      dewiHall: 'DeWiHall.',
      title: 'Gifted Legendary Cats of the Meow Amendment',
      subtitle1: `Under the Meow Amendment #5's "Legendary Grant Provision," the
      DeWiCats team has the unique privilege of gifting 25 Legendary Cats to
      outstanding community members who have shown exceptional support and
      contribution.`,
      subtitle2: `          These Legendary Cats are not just tokens of appreciation; they are
      symbols of excellence and honor within the DeWiCats universe. Each one
      embodies the remarkable spirit and dedication of our community’s most
      notable members.`,
      subtitle3: `With a meow of gratitude, we celebrate these 25 Legendary Cats and the
      incredible individuals they represent. For more details on the Meow
      Amendment #5 and the Legendary Grant Provision, visit `,
    },
    bid: {
      done: 'Winning Bid',
      active: 'Current Bid',
    },
    timeTitle: 'Auction Ends In',
    ownerTitle: 'Held by',
    minimunBid: '{{ bid }} {{ symbol }} or more',
    placeBid: 'Place bid',
    buyNow: 'Buy now',
    cancelBid: 'Cancel Bid',
    cancelAll: 'Cancel All',
    detectedUncancelledBids:
      'We have detected that you have old bids that are no longer valid. Please cancel to recieve your funds back.',
    errors: {
      bidLessThanCurrent: 'Bid amount is less than current bid',
      bidTooLow:
        'Bid amount must be {{ minimunBidIncrement }} or more than current bid',
      auctionHouse: {
        failed: 'Failed in useAuctionHouse: ',
        fetchBids: 'Error fetching bids: ',
        cancelBid: 'Error canceling bid: ',
      },
    },
  },
  editor: {
    commands: {
      continueWriting: {
        title: 'Continue writing',
        description: 'Use AI to expand your thoughts.',
      },
      sendFeedback: {
        title: 'Send Feedback',
        description: 'Let us know how we can improve.',
      },
      text: {
        title: 'Text',
        description: 'Just start typing with plain text.',
      },
      toDoList: {
        title: 'To-do List',
        description: 'Track tasks with a to-do list.',
      },
      heading1: {
        title: 'Heading 1',
        description: 'Big section heading.',
      },
      heading2: {
        title: 'Heading 2',
        description: 'Medium section heading.',
      },
      heading3: {
        title: 'Heading 3',
        description: 'Small section heading.',
      },
      bulletList: {
        title: 'Bullet List',
        description: 'Create a simple bullet list.',
      },
      numberedList: {
        title: 'Numbered List',
        description: 'Create a list with numbering.',
      },
      quote: {
        title: 'Quote',
        description: 'Capture a quote.',
      },
      code: {
        title: 'Code',
        description: 'Capture a code snippet.',
      },
      image: {
        title: 'Image',
        description: 'Upload an image from your computer.',
      },
      error: {
        requestLimit: 'You have reached your request limit for the day.',
        rateLimit: 'Rate Limit Reached',
        generic: 'Something went wrong.',
      },
    },
    general: {
      shortCutUsed: 'Autocomplete Shortcut Used',
      end: 'end',
      confirm: 'AI writing paused. Continue?',
    },
  },
  uploadImages: {
    error: {
      notSupported: 'File type not supported',
      tooBig: 'File size too big (max 20MB)',
      uploading: 'Error uploading image. Please try again.',
      localReadError:
        '`BLOB_READ_WRITE_TOKEN` environment variable not found, reading image locally instead.', // '`BLOB_READ_WRITE_TOKEN` environment variable not found, reading image locally instead.'
    },
    loading: 'Uploading image...',
    success: 'Image uploaded successfully.',
  },
  staking: {
    container: {
      progress: {
        title: 'NEXT TIER',
        label: 'Rare Box',
      },
      title: 'CURRENT BOX',
      subtitle: 'Common Box',
      unlockLabel: '>Unlocks in 21 days',
      nestedPeriod: 'Staked for 41 Days',
    },
  },
  allVotesDialog: {
    title: 'Owner',
    subtitle: 'Choice',
  },
}

export default translation
